<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          v-if="$permission.canWrite()"
          >添加</el-button
        >
        <el-button
          size="mini"
          class="filter-item"
          type="danger"
          @click="delRows"
          v-if="$permission.canDel()"
          >删除</el-button
        >
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="details(row)"
            ></el-button>
            <el-button
              type="text"
              icon="el-icon-truck"
              v-if="row.OrderState == 1"
              @click="send(row)"
            ></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <detail-dialog ref="detailDialog" @close-saved="reload"></detail-dialog>
    <create-dialog ref="createDialog" @close-saved="reload"></create-dialog>
    <send-dialog ref="sendDialog" @close-saved="reload"></send-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sale/order/list";
import detailDialog from "@/components/sale/order/detailDialog";
import createDialog from "@/components/sale/order/createDialog";
import sendDialog from "@/components/sale/deliver/createDialog";

export default {
  name: "order",
  mixins: [curdMixins],
  components: {
    list,
    detailDialog,
    createDialog,
    sendDialog,
  },
  methods: {
    details(row) {
      // this.$refs.detailDialog.openDetailsById(row.RecoredId);
      this.$refs.detailDialog.openDetails(row);
    },
    create(row) {
      // this.$refs.detailDialog.openDetailsById(row.RecoredId);
      this.$refs.createDialog.openCreate(row);
    },
    send(row) {
      console.log(row, "send");
      this.$refs.sendDialog.openCreate(row).then((that) => {
        that.notOrders = false;
        var OrderGoods = row.OrderGoods;
        OrderGoods.forEach((item) => {
          item.OrderNo = row.OrderNo;
          item.OrderDate = row.OrderDate;
          item.Quantity = row.MainunitCount;
        });
        that.setGoods({
          OrderGoods: OrderGoods,
          StoreId: row.StoreId,
          ReceivingPerson: row.ReceivingPerson,
          ReceivingPhone: row.ReceivingPhone,
          ReceivingAddress: row.ReceivingAddress,
        });
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RecordId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>